import { http } from '@/utils/http';
import qs from 'qs';

const baseUrl = 'vote/2020project/2020cjly/controller.php?enews=';
// 列表

export const getlist = (page: any, type: any) => {
  return http.get(`${baseUrl}vote-list`, {
    params: { page, type },
  });
};

export const getDetail = (id: any) => {
  return http.get(`${baseUrl}detail`, {
    params: { id },
  });
};
